module.exports = __webpack_public_path__ + "static/media/fontawesome-webfont.6878d55e.svg";